module.exports = __webpack_public_path__ + "static/jamel-5880ff87253c8e12a787091b78f73e53.png";